import { render, staticRenderFns } from "./workClothes.vue?vue&type=template&id=13c159d7"
import script from "./workClothes.vue?vue&type=script&lang=js"
export * from "./workClothes.vue?vue&type=script&lang=js"
import style0 from "./workClothes.vue?vue&type=style&index=0&id=13c159d7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports